import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../components/ui/table';
import { Alert } from '../components/ui/alert';

export default function StaffCategories() {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const API_URL = process.env.REACT_APP_API_URL || '/api';
        const res = await fetch(`${API_URL}/users/staff-types/`);
        const data = await res.json();
        if (data.success) {
          setTypes(data.data?.staff_types || []);
        } else {
          setError(data.error || data.message || 'Failed to load staff categories');
        }
      } catch (e) {
        setError('Network error while loading staff categories');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="w-full p-6">
      <Card>
        <CardHeader>
          <CardTitle>Staff Categories</CardTitle>
        </CardHeader>
        <CardContent>
          {error && <Alert variant="destructive" className="mb-4">{error}</Alert>}
          {loading ? (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              <p className="mt-2 text-gray-600">Loading...</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Name</TableHead>
                    <TableHead>Description</TableHead>
                    <TableHead>Permissions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {types.map((t) => (
                    <TableRow key={t.id}>
                      <TableCell>{t.name}</TableCell>
                      <TableCell>{t.description || '-'}</TableCell>
                      <TableCell>{t.permissions || '-'}</TableCell>
                    </TableRow>
                  ))}
                  {types.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={3}>
                        <p className="p-4 text-muted-foreground">No staff categories found</p>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
